<template>
    <v-card class="mx-auto">
        <v-snackbar v-model="snackbar.active" :color="snackbar.color" :timeout="4000" top >    
            <span> {{snackbar.message}} </span>
            <v-btn text @click="snackbar.active = false">Close</v-btn>
        </v-snackbar>        
        <v-card-text> 
            <v-container fluid>
                    <v-row align="center" align-content="center" >
                        <v-col cols="12" lg="4" xl="4">
                            <v-card v-for="(item,idx) in items" :key="idx" outlined flat raised>
                                <v-card-title>
                                    {{item.fase}}
                                </v-card-title>
                                <v-card-text>
                                    <v-checkbox v-for="(check,idxs) in item.checklist" :key="idxs"  :label="check.titulo" hide-details dense/>
                                </v-card-text>    
                            </v-card>                     
                        </v-col>                                                                
                    </v-row> 
                <!-- </v-form> -->
            </v-container>                           
        </v-card-text>   
    </v-card> 
</template>
<script>
import { db } from '@/main'
import $ from 'jquery'

export default {
    data: () => ({
        url: '',
        loggedIn: false,
        nome: '',
        link: '',
        contagem: new Date().getTime(),
        rules: {
            required: value => !!value || 'Campo Obrigatório.', 
        },         
        listaPresentes: [],
        loading: false,
        nomePai: '',
        babyData: '',
        nomeMae: '',
        dialog: false,
        sexo: '',
        items: [{
            fase: "Suspeita de Gestação",
            checklist: [
                {
                    titulo: "Teste de Farmácia",
                    descrição: "Deve ser Feito",
                    idx: 1
                },
                {
                    titulo: "Teste de Sangue",
                    descrição: "Deve ser Feito",
                    idx: 2
                }
            ],
        }],
        snackbar: {
            'active':false,
            'color':'success',
            'message':'Deu Certo'
        },        
        apiUrl: 'https://www.googleapis.com/customsearch/v1?searchType=image&key=AIzaSyBkZBJY36Csg1dSWopBEZhceIfSz1zObSY&cx=003413523766221417157:ijmha5ktkqe&q=',
    }),
    async created(){
        this.url = sessionStorage.getItem('accessCode')
        this.loggedIn = sessionStorage.getItem('loggedIn')
        await setTimeout(() => {}, 5000);
        await db.collection('revelacoes').where('URL','==',this.url).get()
        .then((seg) => {    
            this.babyData = seg.docs.map(doc => {let a = doc.data(); a.id = doc.id; return a})[0];
            this.listaPresentes = this.babyData.listaPresentes || []
            this.contagem = this.babyData.dataRevelacao - new Date().getTime()
            this.contagem = this.contagem < 0 ? 0 : this.contagem
            
            
            let nomePai = this.babyData.nomeMamae
            let nomeMae = this.babyData.nomePapai

            this.babyData.FirstNameMamae =  nomePai.substring(0, nomePai.indexOf(" "))
            this.babyData.FirstNamePapai =  nomeMae.substring(0, nomeMae.indexOf(" "))  

            // console.log("roteador", this.$router)

        }).catch(function (error) {
            this.loading = false
            console.error("Error get userss: ", error);
        });              
    },
    methods:{
        saveSex(){
            if (this.sexo == '') {
                this.snackbar =  {
                    'active':true,
                    'color':'warning',
                    'message':'Selecione o Sexo do Bebê para Atualizar'
                } 
            }else{
                let sex =  {
                    'sexo': this.sexo
                }
                db.collection('revelacoes').doc(this.babyData.id).update(sex).then(async() => {
                    this.loading = false
                    this.sexo = ''
                    this.snackbar =  {
                        'active':true,
                        'color':'success',
                        'message':'Sexo Atualizado com Sucesso'
                    }                
                }).catch(function (error) {
                    this.snackbar =  {
                        'active':true,
                        'color':'error',
                        'message':'Falha ao Atualizar o Sexo do Bebê: ' + error
                    }                 
                    console.error('Error to Create Chá: ' + error)
                })  
            }
        },        
        removePresente(value){
            this.listaPresentes.splice(value,1)
            let listaSalvar = {
                "listaPresentes": this.listaPresentes
            }        
            db.collection('revelacoes').doc(this.babyData.id).update(listaSalvar).then(async() => {
                this.loading = false
            }).catch(function (error) {
                console.error('Error to Create Chá: ' + error)
            })                
        },
        async inserirProduto(){
                let listaProdutos = {
                    'link': this.link.substring(this.link.indexOf("//")+2, this.link.length),    
                    'imagem': ''
                }
                console.log(listaProdutos)
                this.getImage().then(async (img) => {
                    console.log("img", img)
                    listaProdutos.imagem = img.link
                    listaProdutos.nome = img.title
                    this.listaPresentes.push(listaProdutos)
                    let listaSalvar = {
                        "listaPresentes": this.listaPresentes
                    }
                    db.collection('revelacoes').doc(this.babyData.id).update(listaSalvar).then(async() => {
                        this.loading = false
                        this.nome = ''
                        this.link = ''
                        this.$refs.form.preventDefault();
                    }).catch(function (error) {
                        console.error('Error to Create Chá: ' + error)
                    })                
                })
        },
        async getImage(){
            let page = this.link.substring(this.link.indexOf('.')+1,this.link.indexOf('.com')+4)
            let nome = this.link.substring(this.link.lastIndexOf('/')+1,this.link.indexOf('?'))
            if (nome.length == 0)
                nome = this.link.substring(this.link.lastIndexOf('.br')+4,this.link.indexOf('?'))        

            if(nome.split("/").length > 2){
                nome = this.link.substring(this.link.lastIndexOf('.br')+4,this.link.length -1)
                nome = nome.substring(nome.lastIndexOf('.br')+4, nome.indexOf('/'))
            }

            console.log("teste", page,nome)
            let teste
            await $.getJSON(this.apiUrl+ page + ' ' + nome, async function(data){
                console.log("items", data)
                teste = await data.items[0]
            })
            return teste
        }
    }
    // <a href='https://br.freepik.com/fotos-vetores-gratis/bebe'>Bebê vetor criado por stockgiu - br.freepik.com</a> 4871100
    // <a href='https://br.freepik.com/fotos-vetores-gratis/logotipo'>Logotipo vetor criado por freepik - br.freepik.com</a> plantilha
    // <a href='https://br.freepik.com/fotos-vetores-gratis/carro'>Carro vetor criado por elsystudio - br.freepik.com</a> artigos de bebe
    // https://br.freepik.com/vetores-gratis/modelo-de-logotipo-adoravel-loja-de-bebe-com-estilo-moderno_3490643.htm#query=bebe&position=3 
}
</script>